import Vue from 'vue';
import App from '@/App';
import vuetify from '@/plugins/vuetify';
import router from '@/router';
import vueSprengnetterCD from '@sprengnetter/vue-cd-components/main';

//Imports Leaflet
import { LControl, LControlLayers, LMap, LMarker, LTileLayer, LWMSTileLayer } from 'vue2-leaflet';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import 'leaflet/dist/leaflet.css';
import '@sprengnetter/vue-cd-components/src/styles/manx/style.scss';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import store from './store';
import './plugins/vee-validate';

// Leaflet Komponenten
Vue.component('l-map', LMap);
Vue.component('l-control-layers', LControlLayers);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-wms-tile-layer', LWMSTileLayer);
Vue.component('l-control', LControl);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.config.productionTip = false;
Vue.use(vueSprengnetterCD);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
